<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="form" :label-width="80" :model="formFields" :rules="ruleValidate">
        <FormItem label="类型名称:" prop="name">
          <Input v-model="formFields.name" placeholder="请输入车辆类型..." size="small" />
        </FormItem>
        <FormItem label="绑定车库:" prop="parkingId">
          <Select
            v-model="formFields.parkingId"
            size="small"
            placeholder="请选择绑定车库..."
            clearable
            filterable
          >
            <Option v-for="(option, index) in garages" :key="index" :value="option.id" :label="option.name" />
          </Select>
        </FormItem>
        <FormItem label="类型排序:" prop="sort">
          <Input v-model="formFields.sort" placeholder="请输入车辆类型排序序号..." size="small" number />
        </FormItem>
        <FormItem label="类型备注:" prop="remarks">
          <Input v-model="formFields.remarks" placeholder="请输入备注..." size="small" />
        </FormItem>
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
import { applyObject } from '@/utils/util'
export default {
  name: 'VehicleDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      garages: this.loadGarages(),
      formFields: {
        name: '',
        remarks: '',
        id: this.id,
        sort: 0
      },
      ruleValidate: {
        name: [
          { required: true, message: '车辆类型不能为空!' }
        ]
      }
    }
  },
  computed: {
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑车辆类型' : '添加新车辆类型'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.$refs.form.resetFields()
      this.loadingStatus = false
      if (this.action && this.id) {
        this.loadingStatus = true
        request({
          url: this.action + '/' + this.id,
          method: 'get'
        }).then(res => {
          applyObject(res.data, this.formFields)
          this.loadingStatus = false
        }).catch(() => {
          // this.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          this.loadingStatus = false
        })
      }
    }
  },
  methods: {
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = res.data
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    },
    saveOrUpdate: function() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.action) {
            this.$refs.form.validate((valid) => {
              if (valid) {
                this.submit = true
                const isNew = this.formFields.id === 0
                request({
                  url: this.action + (isNew ? '' : ('/' + this.id)),
                  method: isNew ? 'POST' : 'PUT',
                  data: this.formFields
                }).then(res => {
                  this.loadingStatus = false
                  this.$Notice.success({
                    title: '数据保存成功',
                    desc: '车辆类型保存成功!'
                  })
                  this.submit = false
                  this.closeModal(true)
                }).catch(() => {
                  // this.$Notice.error({
                  //   title: '服务器数据请求失败',
                  //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
                  // })
                  this.loadingStatus = false
                  this.submit = false
                })
              }
            })
          }
        }
      })
    },
    closeModal: function(changed = false) {
      this.formFields = {
        name: '',
        remarks: '',
        id: 0
      }
      this.$emit('on-close', changed)
    }
  }
}
</script>

